import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkSchedule } from '@models/time-off-v3/works-schedule.model';

@Component({
    templateUrl: './work-schedule-update.view.html',
    styleUrls: ['./work-schedule-update.view.scss'],
})
export class WorkScheduleUpdateView {
    workSchedule: WorkSchedule = new WorkSchedule();
    isLoading = false;

    constructor(private route: ActivatedRoute) {
        this.workSchedule = this.route.snapshot.data.models.get('work-schedule');
    }
}
